module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-15.2c3ad85d.jpg";